module.exports = __webpack_public_path__ + "static/media/ic_hs_b1_myway.56f2ff8c.svg";